// @flow
import * as React from 'react';
import ReactCardFlip from 'react-card-flip';

import { type CardT } from './types';

type State = {
  hover: boolean,
};

export default class Card extends React.Component<CardT, State> {
  state = {
    hover: false,
  };

  render() {
    const {
      visible, image, defaultImage, onCardClick, isDesktop,
    } = this.props;

    const { hover } = this.state;

    return (
      <button
        className="memory-game__card"
        type="button"
        onClick={() => onCardClick(image)}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <ReactCardFlip isFlipped={visible}>
          <div className="memory-game__overlay" key="front">
            <img src={defaultImage} alt="" />
          </div>

          <div className="memory-game__image-box" key="back">
            <img className="memory-game__image" src={image.url} alt={image.description} />
            {visible &&
              hover && isDesktop && <div className="memory-game__description">{image.description}</div>}
          </div>
        </ReactCardFlip>
      </button>
    );
  }
}
